import React, { useCallback, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'

interface DropdownItem {
  name: string
  value?: unknown
}

interface CDropdownProps {
  data?: DropdownItem[] | null
  selectedItem?: DropdownItem | null
  onSelect: (item: DropdownItem) => void
}

function CDropdown({ data, selectedItem, onSelect }: CDropdownProps) {
  const [dropDownOpen, setDropDownOpen] = useState(false)

  const toggleDropDown = useCallback(() => {
    setDropDownOpen(prevState => !prevState)
  }, [])

  const handleSelect = useCallback(
    (item: DropdownItem) => {
      onSelect(item)
      toggleDropDown()
    },
    [onSelect, toggleDropDown]
  )

  return (
    <>
      <Dropdown show={dropDownOpen} onToggle={toggleDropDown}>
        <Dropdown.Toggle
          className="nav-link dropdown-toggle arrow-none"
          as="a"
          role="button"
          onClick={toggleDropDown}
        >
          <span className="align-middle d-none d-lg-inline-block">{selectedItem?.name}</span>
          <i className="ri-arrow-down-s-line d-none d-sm-inline-block align-middle" />
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu dropdown-menu-end dropdown-menu-animated">
          {(data || [])?.map((item, idx) => {
            return (
              <Link
                to=""
                className="dropdown-item"
                key={idx + item?.name}
                onClick={() => handleSelect(item)}
              >
                <span className="align-middle">{item.name}</span>
              </Link>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default CDropdown
